import React from "react";
import data from "../../../data/banter-privacy.json";

const BanterPrivacyPolicy = () => {
  const ListItem = ({ content }) => {
    return (
      <li className="d-flex align-items-start my-2 item">
        <img className="pr-3" src="/images/check.svg" alt="check icon" />
        <p className="m-0">{content}</p>
      </li>
    );
  };

  return (
    <div>
      <div className="banter-hero row">
        <div className="col-12 d-md-none">
          <img src="/images/banter-privacy-hero.svg" alt="Banter privacy policy" />
        </div>
        <div className="col-sm-5 col-sm-offset-1">
          <h1>
            Privacy Policy:
            <br />
            Exetel Banter
          </h1>
          <p>{data.banner.copy}</p>
        </div>
        <div className="col-12 col-sm-5 ml-md-5 d-none d-md-block">
          <img src="/images/banter-privacy-hero.svg" alt="Banter privacy policy" />
        </div>
      </div>
      <div className="row content">
        <div className="col-sm-10 col-sm-offset-1">
          <div className="margin-40">
            <h2 className="m-0">Required for the provision of our service</h2>
            <p>
              The categories of personal data described below is processed and generated when using
              the App. This data is required for technical purposes to increase ease of use for App
              functions and to ensure stability and security.
            </p>
          </div>
          <div className="margin-40">
            <h2 className="mb-0">What personal data we collect and process</h2>
            <p>{data.personal.copy}</p>
            <p>{data.personal.subcopy}</p>
            <div>
              <p>These may include:</p>
              <ul className="list-unstyled m-0 p-0 column-list">
                {data.list.map((item, index) => {
                  return <ListItem content={item} key={index} />;
                })}
              </ul>
            </div>
            <p>{data.additional}</p>
          </div>
          <div className="items">
            {data.items.map((item, key) => {
              return (
                <div key={key} className="item">
                  <img src={`/images/privacy/${item.icon}`} alt={item.title} />
                  <p className="title">{item.title}</p>
                  <p>{item.description}</p>
                </div>
              )
            })}
          </div>
          <p className="m-0 bold">
            For a full list of details please see our{" "}
            <a
              href="https://files.exetel.com.au/terms/ExetelPrivacyPolicy.pdf"
              target="_blank"
              rel="noreferrer"
            >
              privacy policy.
            </a>            
          </p>
        </div>
      </div>
    </div>
  );
};

export default BanterPrivacyPolicy;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/BanterPrivacyPolicy.js